import { Injectable } from '@angular/core';
import { AuthService } from '@app/services';
import { Router } from '@angular/router';
import { JobPosting } from '@models/recruiting/job-posting.model';
import { Employee } from '@models/employee/employee.model';
import { Platform } from '@app/classes';

@Injectable()
export class HiringPermissionsService {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}

    async handle(jobPosting?: JobPosting): Promise<void> {
        const hasRecruitingAdminAccess = this.auth.can(Platform.recruiting.permission.recruiter);

        if (hasRecruitingAdminAccess) {
            return;
        }

        const partOfHiringTeam = jobPosting?.hiringTeam.length ? this.isPartOfHiringTeam(jobPosting.hiringTeam) : false;

        if (partOfHiringTeam) {
            return;
        }

        this.router.navigate(['/', 'recruiting', 'jobPostings']);
    }

    private isPartOfHiringTeam(employees: Employee[]): boolean {
        return employees.map((e: Employee) => e.id).includes(this.auth.employee.id);
    }
}
